module.exports = "<div ng-controller=\"standardCtrl\">\n    <div class=\"error-msg-a\">正在构建中...敬请期待</div>\n</div>";